/* @flow */
import * as React from 'react';

const GiftWhite = props => (
  <svg
    width={24}
    height={22}
    viewBox="0 0 24 22"
    stroke="#FFFFFF"
    strokeWidth={2}
    fill="none"
    fillRule="evenodd"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}>
    <path
      stroke="none"
      strokeWidth={1}
      fill="#FFFFFF"
      fillRule="nonzero"
      d="M18.8,4 C18.9,3.7 19,3.4 19,3 C19,1.3 17.7,0 16,0 C14.9,0 13.1,1.4 12,2.9 C10.9,1.4 9.1,0 8,0 C6.3,0 5,1.3 5,3 C5,3.4 5.1,3.7 5.2,4 L18.8,4 Z M16,2 C16.6,2 17,2.4 17,3 C17,3.6 16.6,4 16,4 L13.7,4 C14.4,3.1 15.5,2.1 16,2 Z M7,3 C7,2.4 7.4,2 8,2 C8.5,2.1 9.7,3.1 10.4,4 L8,4 C7.4,4 7,3.6 7,3 Z"
    />
    <rect x={11} y={5} width={2} height={15} />
    <rect x={1} y={5} width={22} height={4} rx={1} />
    <rect x={2} y={9} width={20} height={12} rx={1} />
  </svg>
);

export default GiftWhite;



// WEBPACK FOOTER //
// ./src/assets/images/icons/gift-white.js